import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
} from '@mui/material';

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    content: React.ReactNode;
    onClose: () => void;
    onConfirm: () => void;
    confirmText?: string;
    cancelText?: string;
    isDeleting?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    content,
    onClose,
    onConfirm,
    confirmText = 'Excluir',
    cancelText = 'Cancelar',
    isDeleting = false,
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ fontSize: '0.9rem' }}>{content}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: '8px 24px 16px' }}>
                <Button onClick={onClose} disabled={isDeleting}>
                    {cancelText}
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
                     {isDeleting ? <CircularProgress size={20} color="inherit" /> : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog; 